import manifest from './curriculum_manifest.json';
import type { Manifest, Subject, Chapter } from './types';

const m = manifest as unknown as Manifest;

export function useCurriculum(boardId?: string, gradeId?: string, subjectId?: string) {
  if (!boardId || !gradeId || !subjectId) return null;
  const boardData = m.boards.find((b) => b.id === boardId);
  if (!boardData) return null;
  const gradeData = boardData.grades.find((g) => g.id === gradeId);
  if (!gradeData) return null;
  const subjectData = gradeData.subjects.find((s) => s.id === subjectId);
  if (!subjectData) return null;
  return { boardData, gradeData, subjectData };
}

export function findChapter(subject: Subject, slug: string): Chapter | null {
  for (const u of subject.units) {
    const ch = u.chapters.find((c) => c.slug === slug);
    if (ch) return ch;
  }
  return null;
}
